// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 59 ? "globe-grid" : chunkId) + "." + {"59":"480be1c7","358":"85fce465"}[chunkId] + ".chunk.js";
};